/**
 * Workshop inquiry actions
 */
export const WORKSHOP_ACTIONS = {
  FORM_STARTED: 'form_started',
  FORM_SUBMITTED: 'form_submitted',
  SUBMISSION_SUCCESS: 'submission_success',
  SUBMISSION_FAILED: 'submission_failed',
} as const;
